import { ScrollScene, addIndicators } from 'scrollscene'; // eslint-disable-line no-unused-vars

class Header {
    constructor() {
        this.body = null;
        this.container = null;
        this.header = null;
        this.sceneSettings = null;
        this.scene = null;
        this.scrollY = 0;
        this.scrollYInitial = window.pageYOffset || document.documentElement.scrollTop;

        this.getElements();
        this.init();
    }

    getElements() {
        this.body = document.querySelector('body');
        this.container = document.querySelector('.header-container');
        this.header = document.querySelector('.header');
    }

    init() {
        this.setSceneSettings();
        this.setScene();
        this.addSceneEvents();
        // this.scrollHideEvent();
        this.scrollMinimiseEvent();
    }

    setSceneSettings() {
        this.sceneSettings = {
            triggerElement: this.container,
            duration: this.container.clientHeight,
            triggerHook: 0,
            controller: {
                reverse: true,
            },
        };
    }

    setScene() {
        this.scene = new ScrollScene(this.sceneSettings);

        // this.scene.Scene.addIndicators();
    }

    addSceneEvents() {
        this.scene.Scene.on('leave', (event) => {
            if (event.scrollDirection === 'FORWARD') {
                this.setFixed();
            }
        });
    }

    setFixed() {
        this.header.classList.add('disable-transition');

        setTimeout(() => {
            this.header.classList.remove('is-static');
        }, 10);

        setTimeout(() => {
            this.header.classList.remove('disable-transition');
        }, 100);
    }

    scrollHideEvent() {
        document.addEventListener(
            'scroll',
            () => {
                const headerDisable =
                    this.header.classList.contains('disable-hide') ||
                    this.header.classList.contains('is-static');

                this.scrollY = window.pageYOffset || document.documentElement.scrollTop;

                if (headerDisable === false) {
                    if (this.scrollY < this.scrollYInitial) {
                        this.header.classList.remove('is-hidden');
                        this.body.classList.remove('nav-hidden');
                    } else {
                        this.header.classList.add('is-hidden');
                        this.header.classList.remove('is-transparent');
                        this.body.classList.add('nav-hidden');
                    }

                    if (this.scrollY < this.header.clientHeight * 0.8) {
                        this.header.classList.remove('is-hidden');
                        this.body.classList.remove('nav-hidden');
                    }
                }

                if (this.scrollY === 0) {
                    this.header.classList.add('is-static', 'is-transparent');
                }

                this.scrollYInitial = this.scrollY;
            },
            { passive: true }
        );
    }

    scrollMinimiseEvent() {
        document.addEventListener(
            'scroll',
            () => {
                const headerDisable =
                    this.header.classList.contains('disable-scroll') ||
                    this.header.classList.contains('is-static');

                const scrollY = window.pageYOffset || document.documentElement.scrollTop;

                if (headerDisable === false) {
                    if (scrollY > this.header.clientHeight) {
                        this.header.classList.add('is-scrolled');
                        this.body.classList.add('nav-scrolled');
                    } else {
                        this.header.classList.remove('is-scrolled');
                        this.body.classList.remove('nav-scrolled');
                    }
                }
            },
            { passive: true }
        );
    }
}

new Header(); // eslint-disable-line no-new
